export default {
    DRAWING_TYPES: {
        1:'Existing 2D',
        2:'New 2D',
        3:'Curb 3D',
        4:'Installation',
        5:'Customer Drawing',
        6:'Engineering',
        7:'Flow',
    },
};